<mat-nav-list>
  <a *ngIf="[UserRoles.ADMIN,UserRoles.EDITOR,UserRoles.VIEWER].includes(loggedInUserRole)" [routerLink]="['/ring-functions']" routerLinkActive="link-active" (click)="dismiss()" mat-list-item>
    <span matListItemTitle>Ringings</span>
    <span matLine>Predefined Ring tones</span>
  </a>
  <a *ngIf="[UserRoles.ADMIN].includes(loggedInUserRole)" [routerLink]="['/configurations']" routerLinkActive="link-active" (click)="dismiss()" mat-list-item>
    <span matListItemTitle>Configurations</span>
    <span matLine>Bell configurations</span>
  </a>
  <a *ngIf="[UserRoles.ADMIN,UserRoles.EDITOR].includes(loggedInUserRole)" [routerLink]="['/schedule-rings']" routerLinkActive="link-active" (click)="dismiss()" mat-list-item>
    <span matListItemTitle>Schedule Rings</span>
    <span matLine>View and modify Scheduled Rings</span>
  </a>
  <a *ngIf="[UserRoles.ADMIN,UserRoles.EDITOR].includes(loggedInUserRole)" [routerLink]="['/modify-ring-patterns']" routerLinkActive="link-active" (click)="dismiss()" mat-list-item>
    <span matListItemTitle>Modfy Ring Patterns</span>
    <span matLine>View and modify Ring Patterns</span>
  </a>
  <a *ngIf="[UserRoles.SUPER_ADMIN].includes(loggedInUserRole)" [routerLink]="['/user-management']" routerLinkActive="link-active" (click)="dismiss()" mat-list-item>
    <span matListItemTitle>Manager Users</span>
    <span matLine>Modify/Create/Delete users</span>
  </a>

  <a *ngIf="[UserRoles.ADMIN,UserRoles.EDITOR,UserRoles.VIEWER].includes(loggedInUserRole)" [routerLink]="['/change-password']" routerLinkActive="link-active" (click)="dismiss()" mat-list-item>
    <span matListItemTitle>Change Password</span>
    <span matLine>Update your account password</span>
  </a>

  <a *ngIf="[UserRoles.SUPER_ADMIN,UserRoles.ADMIN,UserRoles.EDITOR,UserRoles.VIEWER].includes(loggedInUserRole)" [routerLink]="['/action-logs']" routerLinkActive="link-active" (click)="dismiss()" mat-list-item>
    <span matListItemTitle>Action Logs</span>
    <span matLine>View system action logs</span>
  </a>

  <a *ngIf="loggedInUserRole && !isController" (click)="logout()" (click)="dismiss()" mat-list-item>
    <span matListItemTitle>Logout</span>
    <span matLine>Signout from the app</span>
  </a>

</mat-nav-list>
<div style="display: flex; justify-content: center">
  <button style="border: none" (click)="dismiss()"><mat-icon>close</mat-icon></button>
</div>
